export const CREATE_ARCHITECTUREREGULATORS = "CREATE_ARCHITECTUREREGULATORS";   
export const RETRIEVE_ARCHITECTUREREGULATORS = "RETRIEVE_ARCHITECTUREREGULATORS";
export const RETRIEVESINGLE_ARCHITECTUREREGULATORS = "RETRIEVESINGLE_ARCHITECTUREREGULATORS";
export const UPDATE_ARCHITECTUREREGULATORS = "UPDATE_ARCHITECTUREREGULATORS";   
export const DELETE_ARCHITECTUREREGULATORS = "DELETE_ARCHITECTUREREGULATORS"; 